export const formName = 'augur-settings-pipeline-tuning';

export const fieldPipelineTuning = 'pipelineTuning';

export const form = {
  form: formName,
  enableReinitialize: true,
};
